import { atom, selector } from 'recoil';
import { FleetServiceStatus } from '../types/fleet';

export const fleetServicesReloadListState = atom<boolean>({
  key: 'app.fleet.services.reload',
  default: false,
});

export const fleetServicesFiltersState = atom<{
  page: number;
  configurationId?: string;
  status?: FleetServiceStatus;
  search: string;
}>({
  key: 'app.fleet.services.filters',
  default: {
    page: 1,
    configurationId: undefined,
    status: undefined,
    search: '',
  },
});

export const fleetServicesHasAnyFilterState = selector<boolean>({
  key: 'app.fleet.services.filters.any',
  get: ({ get }) => {
    const filters = get(fleetServicesFiltersState);
    const hasConfigurationIdFilter = filters.configurationId !== undefined;
    const hasStatusFilter = filters.status !== undefined;

    return hasConfigurationIdFilter || hasStatusFilter;
  },
});
